<div class="outer-container">
    <div class="language-change-container">
        <div class="language">MY</div>
        <div class="language active">EN</div>
    </div>
    <div class="logo-container">
        <img src='./images/logo.svg'>
    </div>
    <div class="heading-container">
        {{'login.welcome' | translate}}
    </div>
    <!-- <div class="heading-otp-container" *ngIf="enterOtp">
        <div>{{'login.welcomeBack' | translate}}</div>
        <div class="username">{{userDetails?.name || 'Mariam Rashid'}}</div>
    </div> -->
    <div class="enter-pin-text" *ngIf="enterOtp">{{'login.enterPinText' | translate}}</div>
    <div class="form-container">
        <form *ngIf="!enterOtp" [formGroup]="loginForm" #ngForm (ngSubmit)="loginClick()">
            <div class="form-group">
                <label class="no-mark color-fff field-label">
                    {{"login.ICNumber" | translate}}
                </label>
                <input class="border-none txtbox-bg-input" type="text" formControlName="icNumber" (keypress)="isNumberKey($event)" maxlength="12" minlength="12"
                    placeholder="{{ 'login.ICNumberPlaceholder' | translate }}">
            </div>

            <button class="primary-button cursor-pointer" [disabled]="!loginForm.valid">{{ 'login.login' | translate
                }}</button>
        </form>

        <!-- <form *ngIf="enterOtp" [formGroup]="otpForm" #ngForm (ngSubmit)="verifyOtp()">
            <ng-otp-input [config]="{length:6,allowNumbersOnly:true}" (onInputChange)="onOtpChange($event)"
                ></ng-otp-input>
            <div class="forget-pin cursor-pointer" (click)="forgetPinClick()">{{'login.forgetPin' | translate}}</div> -->

            <!-- <div class="display-b" [ngClass]="{'display-n': displayResendCode}">
                <p class="resend-txt" [ngClass]="{'label-ar': lang === 'ar'}">{{ 'login.resendCode' | translate }}: <span id="time">01:00</span></p>
            </div>
           
            <button mat-raised-button *ngIf="displayResendCode" class="help-btn" (click)="resendCode()" [ngClass]="{'btn-ar': lang === 'ar'}">{{ 'login.reSend' | translate }}</button> -->

            <!-- <button class="primary-button cursor-pointer" [disabled]="!otpForm.valid || otpFormControl().length < 6">{{ 'login.login' | translate
                }}</button>
        </form> -->
    </div>
    <div class="register-block d-flex" *ngIf="!enterOtp">
        <div class="register-info">{{'login.newToKT' | translate}}</div>
        <div class="register-link cursor-pointer" (click)="registerClick()">{{'login.register' | translate}}</div>
    </div>

    <div class="products-list-container d-flex">
        <div class="product d-flex" *ngFor="let product of productList">
            <img class="product-img" [src]="product.img">
            <div class="details">{{product.details | translate}}</div>
        </div>
    </div>
</div>